module.exports = __webpack_public_path__ + "static/media/view.4234ef89.svg";